import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getDemographicReportFailed,
    getDemographicReportComplete,
    getDemographicReportStart,
    getPlayerManagementStart,
    getPlayerManagementComplete,
    getPlayerManagementFailure,
    getLivePlayersReportStart,
    getLivePlayersReportComplete,
    getLivePlayersReportFailure,
    getPlayerLiabilityStart,
    getPlayerLiabilitySuccess,
    getPlayerLiabilityFailure,
    getKPISummaryStart,
    getKPISummarySuccess,
    getKPISummaryFailure,
    getKPIReportStart,
    getKPIReportSuccess,
    getKPIReportFailure,
    getGameReportFailure,
    getGameReportSuccess,
    getGameReportStart,
    getPlayerReportFailure,
    getPlayerReportSuccess,
    getPlayerReportStart,
    getPlayerGameReportFailure,
    getPlayerGameReportSuccess,
    getPlayerGameReportStart,
    getElasticHealthStart,
    getElasticHealthComplete,
    getElasticHealthFailure,
    getUserStatsFailure,
    getUserStatsSuccess,
    getUserStatsStart,
  },
  reducer
} = createSlice({
  name: 'dashboard',
  initialState: {
    loading: false,
    playerLoading: false,
    demogData: [],
    topPlayers: null,
    playerLogedInData: null,
    playerLiabilityData: null,
    KPISummary: null,
    KPIReport: null,
    elasticHealth: false,
    PlayerReportLoading: false,
    PlayerReport: null,
    UserStats:null
  },
  reducers: {
    getDemographicReportStart: (state) => ({
      ...state,
      demogLoading: true
    }),
    getDemographicReportComplete: (state, { payload }) => ({
      ...state,
      demogLoading: false,
      demogData: payload
    }),
    getDemographicReportFailed: (state) => ({
      ...state,
      demogLoading: false
    }),
    getPlayerManagementStart: (state) => ({
      ...state,
      playerLoading: true
    }),
    getPlayerManagementComplete: (state, { payload }) => ({
      ...state,
      playerLoading: false,
      playerData: payload
    }),
    getPlayerManagementFailure: (state) => ({
      ...state,
      playerLoading: false
    }),
    getLivePlayersReportStart: (state) => ({
      ...state,
      livePlayerloading: true
    }),
    getLivePlayersReportComplete: (state, { payload }) => ({
      ...state,
      livePlayerloading: false,
      livePlayerData: payload
      // livePlayerData: {
      //   "totalPlayers": "149",
      //   "todayTotalGgr": "0",
      //   "loggedInPlayer": 18,
      //   "depositConvRate": "36.91",
      //   "registrationConvRate": "41.27",
      //   "deviceLoggedIn": [
      //       {
      //           "device_type": "desktop",
      //           "count": "18"
      //       }
      //   ]
      // }
    }),
    getLivePlayersReportFailure: (state) => ({
      ...state,
      livePlayerloading: false
    }),
    getPlayerLiabilityStart: (state) => ({
      ...state,
      playerLiablityLoading: true
    }),
    getPlayerLiabilitySuccess: (state, { payload }) => ({
      ...state,
      playerLiablityLoading: false,
      playerLiabilityData: payload
    }),
    getPlayerLiabilityFailure: (state) => ({
      ...state,
      playerLiablityLoading: false
    }),
    getKPISummaryStart: (state) => ({
      ...state,
      kpiSummeryLoading: true
    }),
    getKPISummarySuccess: (state, { payload }) => ({
      ...state,
      kpiSummeryLoading: false,
      KPISummary: payload
    }),
    getKPISummaryFailure: (state) => ({
      ...state,
      userStatsLoading: false
    }),
    getUserStatsStart: (state) => ({
      ...state,
      userStatsLoading: true
    }),
    getUserStatsSuccess: (state, { payload }) => {
      return {
        ...state,
        userStatsLoading: false,
        UserStats: payload,
      };
    },    
    getUserStatsFailure: (state) => ({
      ...state,
      kpiSummeryLoading: false
    }),
    getKPIReportStart: (state) => ({
      ...state,
      kpiReportLoading: true
    }),
    getKPIReportSuccess: (state, { payload }) => ({
      ...state,
      kpiReportLoading: false,
      KPIReport: payload
    }),
    getKPIReportFailure: (state) => ({
      ...state,
      kpiReportLoading: false
    }),
    getGameReportStart: (state) => ({
      ...state,
      gameReportLoading: true
    }),
    getGameReportSuccess: (state, { payload }) => ({
      ...state,
      gameReportLoading: false,
      gameReport: payload
    }),
    getGameReportFailure: (state) => ({
      ...state,
      gameReportLoading: false
    }),
    getPlayerReportStart: (state) => ({
      ...state,
      PlayerReportLoading: true
    }),
    getPlayerReportSuccess: (state, { payload }) => ({
      ...state,
      PlayerReportLoading: false,
      PlayerReport: payload
    }),
    getPlayerReportFailure: (state) => ({
      ...state,
      PlayerReportLoading: false
    }),
    getPlayerGameReportStart: (state) => ({
      ...state,
      gameReportLoadingPlayer: true
    }),
    getPlayerGameReportSuccess: (state, { payload }) => ({
      ...state,
      gameReportLoadingPlayer: false,
      gameReportPlayer: payload
    }),
    getPlayerGameReportFailure: (state) => ({
      ...state,
      gameReportLoadingPlayer: false
    }),
    getElasticHealthStart: (state) => ({
      ...state
    }),
    getElasticHealthComplete: (state, { payload }) => ({
      ...state,
      elasticHealth: payload
    }),
    getElasticHealthFailure: (state) => ({
      ...state
    })
  }
})

export default reducer

export {
  getDemographicReportFailed,
  getDemographicReportComplete,
  getDemographicReportStart,
  getPlayerManagementStart,
  getPlayerManagementComplete,
  getPlayerManagementFailure,
  getLivePlayersReportStart,
  getLivePlayersReportComplete,
  getLivePlayersReportFailure,
  getPlayerLiabilityStart,
  getPlayerLiabilitySuccess,
  getPlayerLiabilityFailure,
  getKPISummaryStart,
  getKPISummarySuccess,
  getKPISummaryFailure,
  getKPIReportStart,
  getKPIReportSuccess,
  getKPIReportFailure,
  getGameReportFailure,
  getGameReportSuccess,
  getGameReportStart,
  getPlayerGameReportFailure,
  getPlayerGameReportSuccess,
  getPlayerGameReportStart,
  getElasticHealthStart,
  getElasticHealthComplete,
  getElasticHealthFailure,
  getPlayerReportFailure,
  getPlayerReportSuccess,
  getPlayerReportStart,
  getUserStatsFailure,
  getUserStatsSuccess,
  getUserStatsStart,
}
